import {Form, Input} from 'antd';
import styles from './adminMainLayout.module.scss';
// import UploadImage from 'components/Startup/profile/companyImage';
import {useEffect} from 'react';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {UPDATE_ADMIN_PROFILE} from 'graphql/mutations/users';
import {useMutation} from '@apollo/client';
import {toast} from 'react-toastify';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';
import {loginSuccess} from 'redux/store/auth';

export const UpdateAdminProfile = ({form, onClose}) => {
  const adminDetails = useSelector(state => state?.auth?.userData);
  const dispatch = useDispatch();

  useEffect(() => {
    form.setFieldsValue({
      firstName: adminDetails?.user?.firstName,
      lastName: adminDetails?.user?.lastName,
    });
  }, [adminDetails]);

  const [updateAdminProfile, {loading}] = useMutation(UPDATE_ADMIN_PROFILE, {
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
  });

  return (
    <div className={styles.profileModal}>
      <h2>Update Your Profile Names</h2>
      <Form
        onFinish={values =>
          updateAdminProfile({variables: {data: values}})
            .then(({data: {updateAdminProfile}}) => {
              if (
                updateAdminProfile?.statusCode === 500 &&
                updateAdminProfile?.__typename === 'Error'
              ) {
                toast.error(updateAdminProfile?.message);
              } else {
                toast.success('Profile updated successfully');
                dispatch(
                  loginSuccess({
                    userData: {
                      ...adminDetails,
                      user: {
                        ...adminDetails?.user,
                        firstName: values.firstName,
                        lastName: values.lastName,
                      },
                    },
                  }),
                );
                onClose();
              }
            })
            .catch(error => toast.error(error.message))
        }
        layout="vertical"
        form={form}>
        {/* <UploadImage label="Upload Image (OPTIONAL)" /> */}
        <Form.Item
          rules={[{required: true, message: 'First Name is required'}]}
          className={styles.formItem}
          label="First Name"
          name="firstName">
          <Input placeholder="Sam" />
        </Form.Item>
        <Form.Item
          rules={[{required: true, message: 'Last Name is required'}]}
          className={styles.formItem}
          label="Last Name"
          name="lastName">
          <Input placeholder="Doe" />
        </Form.Item>
        <SubmitButton label="Update Profile" disabled={loading} />
      </Form>
    </div>
  );
};
